import BaseApi from "../base";

export default class Partnerships extends BaseApi {

}

